import { getFormattedDate } from './global.util';
import { timing } from 'constants/ui.constants';

export const formatCp = (cp: any) => {
  return {
    id: cp.id,
    idNumber: cp.cp_identification,
    assignedSite: cp.siteName || null,
    country: cp.country || null,
    active: cp.active,
    lastActivity: getFormattedDate(cp?.last_used, timing.DATE) || getFormattedDate(cp?.created_at, timing.DATE),
    lastEdit: getFormattedDate(cp?.updated_at),
    createdAt: getFormattedDate(cp?.created_at),
    created_by_first_name: cp.created_by_first_name || '',
    created_by_last_name: cp.created_by_last_name || '',
    updated_by_first_name: cp.updated_by_first_name || '',
    updated_by_last_name: cp.updated_by_last_name || ''
  };
};

export const formatCpData = (data: any[]) => {
  return data?.map((cp) => formatCp(cp));
};
